import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-footer',
	templateUrl: './Footer.component.html',
	styleUrls: ['./Footer.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class FooterComponent { }
